import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetRoomData } from '../types';

export const GET_ONLY_ROOMS: TypedDocumentNode<IGetRoomData> = gql`
  query getOnlyRooms {
    viewer {
      id
      site {
        id
        rooms {
          capacity
          created
          groupTypes
          id
          staff {
            id
            lastName
            firstName
            role
          }
          startPin
          status
          title
          updated
        }
      }
    }
  }
`;
